module.exports = __webpack_public_path__ + "static/img/bg_benefit_s_super_card.0f8552d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bg_benefit_s_super_card.png
// module id = 53Lf
// module chunks = 0